"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitToJSON = exports.UnitFromJSONTyped = exports.UnitFromJSON = exports.instanceOfUnit = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the Unit interface.
 */
function instanceOfUnit(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUnit = instanceOfUnit;
function UnitFromJSON(json) {
    return UnitFromJSONTyped(json, false);
}
exports.UnitFromJSON = UnitFromJSON;
function UnitFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
    };
}
exports.UnitFromJSONTyped = UnitFromJSONTyped;
function UnitToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
    };
}
exports.UnitToJSON = UnitToJSON;
